import * as React from "react";

export interface CPSpacerProps {
  /** When true, the spacer fills horizontal space using `width`. Default orientation is vertical. */
  horizontal?: boolean;
  /** Height of the spacer when vertical (default: 16). */
  height?: number | string;
  /** Width of the spacer when horizontal (default: 16). */
  width?: number | string;
}

const CPSpacer: React.FC<CPSpacerProps> = ({ horizontal, height, width }) => {
  const style: React.CSSProperties = horizontal
    ? { display: "inline-block", width: width ?? 16 }
    : { height: height ?? 16 };

  return <div style={style} />;
};

export default CPSpacer;
